import React from 'react';
import PropTypes from 'prop-types';
import urlJoin from 'url-join';
import QuickLinks from './quick-links';

function PulseQuickLinks(props) {
    const { name, url } = props;

    const links = [
        {
            id: 'patient-search',
            text: 'Patient Search',
            url: urlJoin(url, '/search'),
        },
    ];

    return <QuickLinks title={name} links={links} />;
}

PulseQuickLinks.propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default PulseQuickLinks;
